
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [ {
label: '港口名称',
value: this.$route.params.PT_NAME
}, {
label: '英文名称',
value: this.$route.params.PT_JNAME
}, {
label: '港口说明',
value: this.$route.params.PT_Remark
}]
console.log(this.$route.params)
}
}



// WEBPACK FOOTER //
// ./src/components/P_PortTypeDetail.vue